import React from "react";
import { useNavigate } from "react-router-dom";
import { NAV_ITEMS, Icon } from "./navConfig";

export default function BottomNav({ activeNav, setSidebarOpen }) {
  const navigate = useNavigate();

  // Selected 5 primary items for the driver's mobile bottom navigation
  const mobileKeys = ["dashboard", "loads", "drivers", "messages", "settings"];

  return (
    <nav className="lg:hidden flex-shrink-0 bg-white border-t border-gray-200 flex" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      {NAV_ITEMS.filter(n => mobileKeys.includes(n.key)).map(item => (
        <button 
          key={item.key} 
          onClick={() => { 
            navigate(item.path); 
            // The question mark ensures it only runs if the prop was actually passed down
            setSidebarOpen?.(false); 
          }}
          className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${activeNav === item.key ? "text-blue-600" : "text-gray-400"}`}
        >
          <div className="relative">
            <Icon d={item.icon} size="w-5 h-5" />
            {/* Optional: Show a tiny red dot if there's a notification badge */}
            {item.badge && (
              <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 border border-white rounded-full"></span>
            )}
          </div>
          <span className="text-[9px] font-medium line-clamp-1">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}